import '../scss/style.scss';

import 'svgxuse';
import smoothscroll from 'smoothscroll-polyfill';

import HexGrid from './modules/HexGrid';
import Menu from './modules/Menu';

const grid = new HexGrid();
grid.init();

const menu = new Menu();
menu.init();